module.exports = __webpack_public_path__ + "img/油位监测.27661e0f.png";